<template>
  <button
    v-if="isFavorite()"
    @click="toggle()"
    class="no-underline bg-green-500 mr-3 lg:mr-0 p-4 text-xl w-full mb-3 text-white hover:bg-green-300 flex flex-row">
    <i class="fa fa-minus text-md mr-3"></i>
    <span>Poista hakemukselta *</span>
  </button>
  <button
    v-else
    @click="toggle()"
    class="no-underline bg-green-500 mr-3 lg:mr-0 p-4 text-xl w-full mb-3 text-white hover:bg-green-300 flex flex-row">
    <i class="fa fa-plus text-md mr-3"></i>
    <span>Lisää hakemukseen *</span>
  </button>
</template>

<script>
import { useStore } from "vuex"
import useOptions from "../use/options";

export default {
  name: 'Favorite',
  setup() {
    const store = useStore()
    const { toggleFavorite } = useOptions()
    const options = window.favoriteOptions ?? null

    return {
      toggle() {
        if ( ! options) {
          return null
        }

        toggleFavorite(options)
      },
      isFavorite() {
        if ( ! options) {
          return null
        }

        return store.getters.isFavorite(options)
      }
    }
  }
}
</script>
